import throttle from "raf-throttle";

export default function debouncedResize(callback) {
    var tick;
    window.addEventListener("resize", (e) => {
        let tock = Date.now();
        tick = tock;
        setTimeout(() => {
            if (tick === tock) {
                callback(e);
            }
        }, 1000);
    });
}

export const title = function (el) {
    el.classList.add("in");
    let previous = 0;
    console.log(window.innerWidth, document.body.clientWidth);
    if (window.innerWidth > document.body.clientWidth) {
        if (el.querySelector(".last")) {
            function init() {
                el.querySelector(".topbar__title-inner").classList.add(
                    "no-animation"
                );

                console.log(el.querySelector(".last").getBoundingClientRect());
                const containerLeft = el.getBoundingClientRect().left;
                const selectionLeft = el
                    .querySelector(".last")
                    .getBoundingClientRect().left;
                const offset = selectionLeft - containerLeft;

                setTimeout(function () {
                    el.querySelector(".topbar__title-inner").classList.remove(
                        "no-animation"
                    );
                }, 1000);
                el.querySelector(".topbar__title-inner").style.transform =
                    "translateX(" + (previous - offset) + "px)";

                previous = previous - offset;
            }

            function isScrolled() {
                let a = window.pageYOffset;
                if (a > 100 && !document.body.classList.contains("scrolled")) {
                    document.body.classList.add("scrolled");
                } else if (
                    a <= 100 &&
                    document.body.classList.contains("scrolled")
                ) {
                    document.body.classList.remove("scrolled");
                }
            }

            const throttled = throttle(isScrolled);

            if (window.innerWidth >= 480) {
                window.addEventListener("scroll", throttled);
            }

            debouncedResize((e) => {
                init();
            });

            init();
        }
    }
};
